import { render } from "./TaxiContinue.vue?vue&type=template&id=3890b5c0"
import script from "./TaxiContinue.vue?vue&type=script&lang=js"
export * from "./TaxiContinue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__